/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { logoutSuccess } from '../../redux/reducers/Auth';
import { getCommonInfo, getPAGAA000, postLogout } from '../../services/Api';
import { decodeToken, updateMenuVisibility } from '../../utils';
import {
    MENU_CUSTOMER_SERVICE_CENTER,
    MENU_DENTAL_PLUS,
    MENU_RECRUIT,
    MENU_RESUME,
    MENU_SIDENAV_DENTAL,
    MENU_SIDENAV_USER,
} from '../constants/app';
import SlideTransition from './animations/SlideTransition';
import JWTRemainingTime from './JWTRemainingTime';

const Navbar = () => {
    const location = useLocation();
    const [isMenuActive, setMenuActive] = useState(false);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const token = login.token;
    const decode = decodeToken(token);
    const [info, setInfo] = useState({});
    const [infoToken, setInfoToken] = useState({});
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const popupRef = useRef(null);
    const [showRenewButton, setShowRenewButton] = useState(false);
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const RENEWAL_THRESHOLD = 120 * 60 * 1000;

    const toggleMenu = () => {
        setMenuActive(!isMenuActive);
    };

    const handleNavigation = (targetUrl, e) => {
        if (location.pathname === targetUrl) {
            e.preventDefault();
            window.location.reload();
        }
    };

    const isActive = (menu) => {
        const path = location.pathname.split('-')[0];
        const result = path.split('/').pop().split('-')[0];

        return menu.some(
            (item) =>
                item.url === `/${result}` ||
                (item.child &&
                    Array.isArray(item.child) &&
                    item.child.some((childItem) => childItem.url === `/${result}`)) ||
                (item.urlCpnItem && item.urlCpnItem === `/${result}`) ||
                (item.internalUrl && item.internalUrl[0] === `/${result}`),
        );
    };

    const calculateRemainingTime = () => {
        if (!decode) return;

        const expirationTime = decode.exp * 1000;
        const currentTime = Date.now();
        const timeRemaining = expirationTime - currentTime;

        if (timeRemaining <= 0) {
            dispatch(logoutSuccess());
            setShowRenewButton(false);
        } else {
            setShowRenewButton(timeRemaining < RENEWAL_THRESHOLD);
        }
    };

    useEffect(() => {
        calculateRemainingTime();

        const timer = setInterval(() => {
            calculateRemainingTime();
        }, 1000);

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                calculateRemainingTime();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(timer);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [decode]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setDentalPlusMenu(updatedDentalPlusMenu);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));

        if (loggedIn) {
            getCommonInfo()
                .then(({ data }) => {
                    setInfo(data);
                })
                .catch((error) => console.log(error));

            setInfoToken(decodeToken(token));
        }
    }, [loggedIn, token, location.pathname]);

    const handleTogglePopup = (e) => {
        e.preventDefault();
        setIsPopupOpen((prev) => !prev);
    };

    const renderMenu = (menu) =>
        menu.flatMap((item, index) =>
            item.child ? (
                <li
                    key={`menu-${index}`}
                    onClick={(e) => {
                        localStorage.removeItem('activedUrl');
                        handleNavigation(item.url, e);
                    }}
                >
                    <Link to={item.urlCommon}>{item.context}</Link>
                </li>
            ) : (
                <li
                    key={`menu-${index}`}
                    onClick={(e) => {
                        localStorage.removeItem('activedUrl');
                        handleNavigation(item.url, e);
                    }}
                >
                    <Link to={item.url}>{item.context}</Link>
                </li>
            ),
        );

    // const handleLogout = () => {
    //     postLogout()
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 localStorage.removeItem('activeColorMenu');
    //                 localStorage.removeItem('lastVisitedUrl');
    //                 localStorage.removeItem('activePopUpMenu');
    //                 sessionStorage.removeItem('authPassVerified');
    //                 localStorage.removeItem('savedPAEAA010Conditions');
    //                 localStorage.removeItem('savedPAFAA010Conditions');
    //                 dispatch(logoutSuccess());
    //                 window.location.reload();
    //             }
    //         })
    //         .catch((error) => console.log(error));

    //     navigate('/');
    // };

    const handleLogout = async () => {
        try {
            await postLogout();
        } catch (error) {
            console.error('Logout API failed:', error);
        } finally {
            localStorage.clear();
            sessionStorage.clear();
            dispatch(logoutSuccess());
            window.location.href = '/';
        }
    };
    const handleSaveUrl = (url) => {
        localStorage.setItem('lastVisitedUrl', url);
    };

    const handleClickOutSidePopup = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setIsPopupOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutSidePopup);
        return () => {
            document.removeEventListener('mousedown', handleClickOutSidePopup);
        };
    }, [isPopupOpen]);

    useEffect(() => {
        if (isPopupOpen) {
            setIsPopupOpen(false);
        }
    }, [location.pathname]);
    return (
        <div id="navbar">
            <div className="container">
                <div className="navbar-wrap">
                    <div className="menu">
                        <Link className="icon-popup-mega-menu" onClick={toggleMenu}>
                            <i className={`icon ${isMenuActive ? 'icon-x' : 'icon-hamburger-bar'}`} />
                        </Link>
                        <ul
                            onClick={() => {
                                localStorage.removeItem('activedUrl');
                            }}
                        >
                            <li>
                                <NavLink
                                    to={MENU_RECRUIT[0].url}
                                    className={isActive(MENU_RECRUIT) ? 'active' : ''}
                                    onClick={(e) => handleNavigation(MENU_RECRUIT[0].url, e)}
                                >
                                    채용정보
                                </NavLink>
                                <ul className="submenu">
                                    {MENU_RECRUIT.map((item, index) => (
                                        <li
                                            key={'recruit_' + index}
                                            onClick={(e) => {
                                                handleSaveUrl(item.url);
                                                handleNavigation(item.url, e);
                                            }}
                                        >
                                            <NavLink to={item.url}>{item.context}</NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <NavLink
                                    to={MENU_RESUME[0].url}
                                    className={isActive(MENU_RESUME) ? 'active' : ''}
                                    onClick={(e) => handleNavigation(MENU_RESUME[0].url, e)}
                                >
                                    인재정보
                                </NavLink>
                                <ul className="submenu">
                                    {MENU_RESUME.map((item, index) => (
                                        <li
                                            key={'resume_' + index}
                                            onClick={(e) => {
                                                handleSaveUrl(item.url);
                                                handleNavigation(item.url, e);
                                            }}
                                        >
                                            <NavLink to={item.url}>{item.context}</NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <NavLink
                                    to={dentalPlusMenu[0]?.url}
                                    className={isActive(MENU_DENTAL_PLUS) ? 'active' : ''}
                                    onClick={(e) => handleNavigation(dentalPlusMenu[0]?.url, e)}
                                >
                                    덴탈플러스
                                </NavLink>
                                <ul className="submenu">
                                    {dentalPlusMenu.map((item, index) => (
                                        <li
                                            key={'dental_plus_' + index}
                                            onClick={(e) => {
                                                handleSaveUrl(item.url);
                                                handleNavigation(item.url, e);
                                            }}
                                        >
                                            <NavLink to={item.url}>{item.context}</NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <NavLink
                                    to={customerServiceMenu[0]?.url}
                                    className={isActive(MENU_CUSTOMER_SERVICE_CENTER) ? 'active' : ''}
                                    onClick={(e) => handleNavigation(customerServiceMenu[0]?.url, e)}
                                >
                                    고객센터
                                </NavLink>
                                <ul className="submenu">
                                    {customerServiceMenu.map((item, index) => (
                                        <li
                                            key={'customer_service_center_' + index}
                                            onClick={(e) => {
                                                handleSaveUrl(item.url);
                                                handleNavigation(item.url, e);
                                            }}
                                        >
                                            <NavLink to={item.url}>{item.context}</NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            {loggedIn && infoToken.authorities === 'ROLE_P' && (
                                <li>
                                    <NavLink
                                        to="/paiaa010"
                                        className={isActive(MENU_SIDENAV_USER) ? 'active' : ''}
                                        onClick={(e) => handleNavigation('/paiaa010', e)}
                                    >
                                        마이 페이지
                                    </NavLink>
                                    <ul className="submenu">
                                        {MENU_SIDENAV_USER.flatMap((item, index) =>
                                            item.child ? (
                                                <li
                                                    key={'mypage_p_menu_' + index}
                                                    onClick={(e) => {
                                                        handleSaveUrl(item.url);
                                                        handleNavigation(item.url, e);
                                                    }}
                                                >
                                                    <NavLink to={item.urlCommon}>{item.context}</NavLink>
                                                </li>
                                            ) : (
                                                <li
                                                    key={'mypage_p_menu_' + index}
                                                    onClick={(e) => {
                                                        handleSaveUrl(item.url);
                                                        handleNavigation(item.url, e);
                                                    }}
                                                >
                                                    <NavLink to={item.url}>{item.context}</NavLink>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </li>
                            )}
                            {loggedIn && infoToken.authorities === 'ROLE_C' && (
                                <li>
                                    <NavLink
                                        to="/pajaa010"
                                        className={isActive(MENU_SIDENAV_DENTAL) ? 'active' : ''}
                                        onClick={(e) => handleNavigation('/pajaa010', e)}
                                    >
                                        마이 페이지
                                    </NavLink>
                                    <ul className="submenu">
                                        {MENU_SIDENAV_DENTAL.flatMap((item, index) =>
                                            item.child ? (
                                                <li
                                                    key={'mypage_c_menu_' + index}
                                                    onClick={(e) => {
                                                        handleSaveUrl(item.url);
                                                        handleNavigation(item.url, e);
                                                    }}
                                                >
                                                    <NavLink to={item.urlCommon}>{item.context}</NavLink>
                                                </li>
                                            ) : (
                                                <li
                                                    key={'mypage_c_menu_' + index}
                                                    onClick={(e) => {
                                                        handleSaveUrl(item.url);
                                                        handleNavigation(item.url, e);
                                                    }}
                                                >
                                                    <NavLink to={item.url}>{item.context}</NavLink>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="auth">
                        {loggedIn ? (
                            <>
                                <div className="auth-logged">
                                    {infoToken?.authorities === 'ROLE_C' && (
                                        <Link className="user-notify" to="/pajad010" title="미열람 지원자">
                                            <div className="icon icon-user-subpage"></div>
                                            <div className="count-notify">
                                                {info?.resumeNotViewed > 99 ? '99+' : info.resumeNotViewed}
                                            </div>
                                        </Link>
                                    )}
                                    <div
                                        className="letter-notify"
                                        onClick={() => {
                                            navigate(infoToken?.authorities === 'ROLE_P' ? '/paiaf010' : '/pajah010');
                                        }}
                                        title="미열람 쪽지"
                                    >
                                        <div className="icon icon-letter" />
                                        <div className="count-notify">
                                            {info?.unreadProposeCount > 99 ? '99+' : info.unreadProposeCount}
                                        </div>
                                    </div>
                                    <Link
                                        className={`profile-setting logged ${isPopupOpen && 'active'} `}
                                        onClick={handleTogglePopup}
                                    >
                                        <div className="avatar">
                                            {infoToken?.authorities === 'ROLE_P' ? (
                                                <img src="./images/default-avatar-header.png" alt="avatar" />
                                            ) : (
                                                <img src="./images/default-avatar-headerC.png" alt="avatar" />
                                            )}
                                        </div>
                                        <div className="name">
                                            <span>{info.nameKor} 님</span>
                                        </div>
                                    </Link>
                                    {showRenewButton && <JWTRemainingTime decode={decode} />}
                                    <div
                                        ref={popupRef}
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '20px',
                                        }}
                                    >
                                        <SlideTransition inProp={isPopupOpen} direction="down">
                                            <div className="profile-setting-popup active">
                                                <ul>
                                                    {infoToken.authorities === 'ROLE_P' && (
                                                        <>
                                                            <li>
                                                                <Link
                                                                    to="/paiaa010"
                                                                    onClick={(e) => handleNavigation('/paiaa010', e)}
                                                                >
                                                                    마이 페이지
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/paiab020"
                                                                    onClick={(e) => handleNavigation('/paiab020', e)}
                                                                >
                                                                    이력서관리
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/paiah020"
                                                                    onClick={(e) => handleNavigation('/paiah020', e)}
                                                                >
                                                                    내 정보 수정
                                                                </Link>
                                                            </li>
                                                        </>
                                                    )}
                                                    {infoToken.authorities === 'ROLE_C' && (
                                                        <>
                                                            <li>
                                                                <Link
                                                                    to="/pajaa010"
                                                                    onClick={(e) => handleNavigation('/pajaa010', e)}
                                                                >
                                                                    마이 페이지
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/pajab010"
                                                                    onClick={(e) => handleNavigation('/pajab010', e)}
                                                                >
                                                                    치과정보 관리
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/pajac010"
                                                                    onClick={(e) => handleNavigation('/pajac010', e)}
                                                                >
                                                                    채용정보 관리/영수증
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/pajak010"
                                                                    onClick={(e) => handleNavigation('/pajak010', e)}
                                                                >
                                                                    열람권 관리/영수증
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/pajal010"
                                                                    onClick={(e) => handleNavigation('/pajal010', e)}
                                                                >
                                                                    열람권 사용 현황
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    to="/pajaj020"
                                                                    onClick={(e) => handleNavigation('/pajaj020', e)}
                                                                >
                                                                    내 정보 수정
                                                                </Link>
                                                            </li>
                                                        </>
                                                    )}
                                                    <li>
                                                        <Link onClick={handleLogout}>로그아웃</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </SlideTransition>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <Link to="/login">로그인</Link>
                                <Link to="/padaa010">회원가입</Link>
                            </>
                        )}
                    </div>

                    <div className={`mega-menu ${isMenuActive ? 'active' : ''}`}>
                        <div className="container">
                            <div className="row row-question">
                                <div className="col-xl-3">
                                    <span>채용 공고를 찾는다면?!</span>
                                </div>
                                <div className="col-xl-3">
                                    <span>인재정보를 찾는다면?!</span>
                                </div>
                                <div className="col-xl-3" />
                                <div className="col-xl-3" />
                                {/* {loggedIn && <div className="col-xl-2" />}
                                <div className="col-xl-2">
                                    <span>덴탈잡 이용 안내</span>
                                </div> */}
                            </div>
                            <div className="row row-menu">
                                <div className="col-xl-3">
                                    <h5>채용정보</h5>
                                    <ul>
                                        {MENU_RECRUIT.map((item, index) => (
                                            <li key={'total_recruit_' + index}>
                                                <Link
                                                    to={item.url}
                                                    onClick={(e) => {
                                                        handleNavigation(item.url, e);
                                                        toggleMenu();
                                                    }}
                                                >
                                                    {item.context}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-xl-3">
                                    <h5>인재정보</h5>
                                    <ul>
                                        {MENU_RESUME.map((item, index) => (
                                            <li key={'total_resume_' + index}>
                                                <Link
                                                    to={item.url}
                                                    onClick={(e) => {
                                                        handleNavigation(item.url, e);
                                                        toggleMenu();
                                                    }}
                                                >
                                                    {item.context}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-xl-3">
                                    <h5>덴탈플러스</h5>
                                    <ul>
                                        {dentalPlusMenu.map((item, index) => (
                                            <li key={'total_dental_plus_' + index}>
                                                <Link
                                                    to={item.url}
                                                    onClick={(e) => {
                                                        handleNavigation(item.url, e);
                                                        toggleMenu();
                                                    }}
                                                >
                                                    {item.context}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-xl-3">
                                    <h5>고객센터</h5>
                                    <ul>
                                        {customerServiceMenu.map((item, index) => (
                                            <li key={'total_customer_service_center_' + index}>
                                                <Link
                                                    to={item.url}
                                                    onClick={(e) => {
                                                        handleNavigation(item.url, e);
                                                        toggleMenu();
                                                    }}
                                                >
                                                    {item.context}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {loggedIn && (
                                    <div className="col-xl-2">
                                        <h5>마이 페이지</h5>
                                        <ul>
                                            {infoToken.authorities === 'ROLE_P' && renderMenu(MENU_SIDENAV_USER)}
                                            {infoToken.authorities === 'ROLE_C' && renderMenu(MENU_SIDENAV_DENTAL)}
                                        </ul>
                                    </div>
                                )}

                                {/* <div className={`${loggedIn ? 'col-xl-2' : 'col-xl-4'} "last-column-mega-menu"`}>
                                    <ul>
                                        <li>
                                            <i className="top-menu">개인 회원이라면?</i>
                                        </li>
                                        <li>
                                            <h6>
                                                <Link to="#">
                                                    이력서 등록 <span />
                                                </Link>
                                            </h6>
                                            <span>기본 이력서 등록으로 편한 채용서비스를 이용할 수 있어요.</span>
                                        </li>
                                        <li>
                                            <i className="top-text">치과 회원이라면?</i>
                                        </li>
                                        <li>
                                            <h6>
                                                <Link to="#">
                                                    채용정보 관리/영수증 <span />
                                                </Link>
                                            </h6>
                                            <span>우리 치과 채용공고를 한눈에 관리할 수 있어요</span>
                                        </li>
                                        <li>
                                            <h6>
                                                <Link to="#">
                                                    추천 인재 <span />
                                                </Link>
                                            </h6>
                                            <span>내게 맞는 공고를 확인할 수 있어요</span>
                                        </li>
                                        <li>
                                            <h6>
                                                <Link to="#">
                                                    이용안내 <span />
                                                </Link>
                                            </h6>
                                            <span>회원가입부터 각 메뉴에 대한 간단한 설명을 들을 수 있어요.</span>
                                        </li>
                                        <li>
                                            <h6>
                                                <Link to="#">
                                                    사이트 소개 <span />
                                                </Link>
                                            </h6>
                                            <span>덴탈잡 사이트 서비스에 대한 간략한 설명을 들을 수 있어요</span>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
